import { faCamera } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type Props = {
    onClick: () => void;
    isActive?: boolean;
};

export default function ControlButton({ onClick, isActive = false }: Props) {
    return (
        <button
            type="button"
            className={`focus-control-btn${isActive ? " active" : ""}`}
            onClick={(e) => {
                e.stopPropagation();
                onClick();
            }}
            title={isActive ? "Exit camera control" : "Control HoloCam"}
        >
            <FontAwesomeIcon icon={faCamera} />
            <span className="focus-control-label">{isActive ? "Controlling" : "Control"}</span>

            <style>{`
                .focus-control-btn {
                    display: inline-flex;
                    align-items: center;
                    gap: 6px;
                    background: rgba(8, 10, 16, 0.82);
                    backdrop-filter: blur(10px);
                    -webkit-backdrop-filter: blur(10px);
                    border: 1px solid rgba(255, 255, 255, 0.18);
                    border-radius: 10px;
                    color: #f8fafc;
                    font-size: 0.8rem;
                    font-weight: 600;
                    padding: 8px 12px;
                    cursor: pointer;
                    transition: background 0.15s, border-color 0.15s, color 0.15s;
                    font-family: inherit;
                    box-shadow: 0 6px 18px rgba(0,0,0,0.35);
                    pointer-events: auto;
                    -webkit-transform: translateZ(0);
                    transform: translateZ(0);
                    position: relative;
                    z-index: 30;
                }

                .focus-control-btn:hover {
                    background: rgba(37, 99, 235, 0.88);
                    border-color: transparent;
                    color: white;
                }

                .focus-control-btn.active {
                    background: rgba(37, 99, 235, 0.94);
                    border-color: transparent;
                    color: white;
                }

                .focus-control-label {
                    font-size: 0.78rem;
                    font-weight: 650;
                    letter-spacing: 0.01em;
                }

                @media (max-width: 768px) {
                    .focus-control-btn {
                        padding: 8px;
                        border-radius: 50%;
                        width: 36px;
                        height: 36px;
                        justify-content: center;
                    }
                    .focus-control-label { display: none; }
                }
            `}</style>
        </button>
    );
}
